import flatpickr from "flatpickr";

(function(){
    'use strict';


    function setupDatePickers() {
        
        // From datepicker field
        $(".meetings-search__form #startDate").prop("readonly", false).flatpickr({
            altInput: true,
            altFormat: "d/m/Y",
            altInputClass: "date-selection__input flatpickr-input",
            dateFormat: "U",
        });
        
        // To datepicker field
        // Note: This field should store the end of the day timestamp
        // E.g. If a user selects From 01/01/22 To 01/01/22, we need to ensure that user is searching between start of 01/01/22 to right before 02/01/22
        // Set up this field to translate the date picked properly
        $(".meetings-search__form #toDate").prop("readonly", false).flatpickr({
            altInput: true,
            altFormat: "d/m/Y",
            altInputClass: "date-selection__input flatpickr-input",
            dateFormat: "U",
            onChange: function(selectedDates, dateStr, instance) {
                
                // Store 1 second before midnight of the next day in the real hidden input field
                // We do it this way so that when the page is reloaded, the unix time stored can still be used by flatpickr to show the selected day
                // e.g. if I selected 01/01/21, I want 01/01/21 to show when the page is reloaded. Having the time a second before midnight allows this
                // $(instance.input).val(Number(dateStr) + 86399);
                
                if ( selectedDates.length != 0 ) {
                    $(instance.input).val(Number(dateStr) + 86399);
                }
                    
            },
            
        });
        
    }
    
    // Initialise dates picker fields
    document.addEventListener("DOMContentLoaded", function () {
        
        setupDatePickers();
 
    });

}());
